export const INCREMENT_DATE = "INCREMENT_DATE";
export const DECREMENT_DATE = "DECREMENT_DATE";
export const GET_OCCUPANCIES_REQUEST = "GET_OCCUPANCIES_REQUEST";
export const GET_OCCUPANCIES_SUCCESS = "GET_OCCUPANCIES_SUCCESS";
export const GET_OCCUPANCIES_REJECT = "GET_OCCUPANCIES_REJECT";
export const CREATE_OCCUPANCY_REQUEST = "CREATE_OCCUPANCY_REQUEST";
export const CREATE_OCCUPANCY_SUCCESS = "CREATE_OCCUPANCY_SUCCESS";
export const CREATE_OCCUPANCY_REJECT = "CREATE_OCCUPANCY_REJECT";
export const EDIT_OCCUPANCY_REQUEST = "EDIT_OCCUPANCY_REQUEST";
export const EDIT_OCCUPANCY_SUCCESS = "EDIT_OCCUPANCY_SUCCESS";
export const EDIT_OCCUPANCY_REJECT = "EDIT_OCCUPANCY_REJECT";



// WEBPACK FOOTER //
// ./src/rooms/occupancy/constants.js